/**
 * index.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 새소식과 관련된 데이터 통신 메서드가 저장되어 있습니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import APIClient from "common-modules/general/Model/APIClientModel";
import { ResponseHomeNewsDetail, ResponseHomeNews } from "./types";
import { cdBizLnd } from 'data/configs';

export interface INewsListProps {
  keyword?: string;
  page?: number;
}

/**
 * 단지 정보 가져오기
 */
export const getNewsData = ({ keyword, page }: INewsListProps) =>
  APIClient.sales.get<ResponseHomeNews>(
    `news/list/${cdBizLnd ? `${cdBizLnd}?` : ""}page=${
      page ? page : ""
    }&keyword=${keyword ? encodeURIComponent(keyword) : ""}`
  );

/**
 * 단지 정보 - 상세정보 가져오기
 */
export const getNewsDetailData = (data: string, noUperWrtSral: number) =>
  APIClient.sales.get<ResponseHomeNewsDetail>(
    `/news/${data}?noUperWrtSral=${noUperWrtSral ? noUperWrtSral : ""}`
  );
